import React, { useEffect,useState } from 'react';

import { connect } from 'react-redux';

import { AppWrapper, Block } from 'components';
import Breadcrumbs from 'components/BreadCrumbs/BreadCrumbs';
import PromoCodesForm from 'components/PromoCodesForm/PromoCodesForm';
import PromoCodesList from 'components/PromoCodesList/PromoCodesList';
import ToggleSearchBar from 'components/ToggleSearchBar/ToggleSearchBar';
import AuthProtected from 'containers/AuthProtected/AuthProtected';
import { actions as promoManagerActions } from 'coupon-common/src/modules/admin/promoManager'; // 👈 adjust path
import { dispatchAsAsync } from 'coupon-common/src/utils';


const PromoCodesManager = ({
    dispatch,
    promoCodes,
    fetching,
}) => {
    const [isActive, setIsActive] = useState("manage");
    const [searchQuery, setSearchQuery] = useState("");
    const [loading, setLoading] = useState(false);
    const handleChange = (value) => {
        setIsActive(value);
    };

    // 🔥 Fetch promo codes on load
    useEffect(() => {
        dispatch(promoManagerActions.getPromoCodes());
    }, [dispatch]);

    // 🔥 Create promo
    const handleCreatePromo = async (payload) => {
        try {
            setLoading(true)
            const result = await dispatchAsAsync(
                promoManagerActions.createPromoCode(payload),
                dispatch
            );
            if (result.success) {
                window.alert("Successfully created promo code")
                setIsActive("manage"); // switch back
            }
            else {
                window.alert("Failed to create")
            }
        } catch (error) {
            window.alert("Failed to create")
        }
        finally{
            setLoading(false)
        }
    };

    // 🔥 Update promo
    const handleUpdatePromo = async (id, payload) => {
        try {
            setLoading(true);
            const result = await dispatchAsAsync(
                promoManagerActions.updatePromoCode(id, payload),
                dispatch
            );
            if (result?.success) {
                await dispatchAsAsync(
                    promoManagerActions.getPromoCodes(),
                    dispatch
                );
                window.alert("Successfully updated promo code")

            }
            else {
                window.alert("Failed to update")
            }


        } catch (err) {
            window.alert("Failed to update")
        }
        finally{
            setLoading(false)
        }
    };

    return (
        <AppWrapper
            showHeader
            showSideNav
            showHeadingRow
            headingText={"Promo Codes Manager"}
        >
            <AuthProtected />

            <div className='col-md-12'>
                <Breadcrumbs locationArray={['Admin', 'Promo Codes Manager']} />

                <Block>
                    <div className='container'>
                        <ToggleSearchBar
                            options={[
                                { label: "Manage Promo", value: "manage" },
                                { label: "Create Promo", value: "create" }
                            ]}
                            activeValue={isActive}
                            onChange={handleChange}
                            onSearch={(value) => setSearchQuery(value)}
                        />
                    </div>

                    {/* LIST */}
                    {isActive === "manage" && (
                        <PromoCodesList
                            promoCodes={promoCodes}
                            loading={loading}
                            onUpdate={handleUpdatePromo}
                            searchQuery={searchQuery}
                        />
                    )}

                    {/* CREATE */}
                    {isActive === "create" && (
                        <PromoCodesForm
                            mode="create"
                            onSubmit={handleCreatePromo}
                            loading={loading}
                        />
                    )}
                </Block>
            </div>
        </AppWrapper>
    );
};

const mapStateToProps = (state) => ({
    promoCodes: state.promoCodes?.data || [],
    fetching: state.promoCodes?.fetching,
    error: state.promoCodes?.error,
});

export default connect(mapStateToProps)(PromoCodesManager);